<template>
    <tr>
        <td>
            <input type="text" class="input_s w_full" :placeholder="$t('reservation_settings.section_program_management.placeholder_program_title')" :maxlength="100"
                v-model="program.title" @input="updateItem()">
            </td>
        <td>
            <input type="text" class="input_s w_full" placeholder="30" :maxlength="3"
                v-model="program.duration" @input="updateItem()" oninput="this.value = this.value.replace(/[^0-9]/g, '');">
        </td>
        <td>
            <input type="text" class="input_s w_full" :placeholder="$t('reservation_settings.section_program_management.placeholder_manual_therapy')" 
                v-model="program.description" @input="updateItem()">
        </td>
        <td>
            <div class="btn_group">
                <button class="btn btn_xs btn_lgray_line" :disabled="index == 0" @click="handlerMoveToFirst()">
                    <v-icon>mdi-chevron-double-up</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == 0" @click="handlerMoveToPrevious()">
                    <v-icon>mdi-chevron-up</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == (programs.length - 1)" @click="handlerMoveToNext()">
                    <v-icon>mdi-chevron-down</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == (programs.length - 1)" @click="handlerMoveToLast()">
                    <v-icon>mdi-chevron-double-down</v-icon>
                </button>
            </div>
        </td>
        <td class="txt_center">
            <button class="btn btn_s btn_dgray" @click="removeItem()">－ {{ $t('common.delete') }}</button>
        </td>
    </tr>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { SpaceNavigationAction } from '../Enums/SpaceNavigationAction.js'

export default {
    props: {
        item: Object,
        index: Number,
        programs: Array
    },
    data() {
        return {
            program: {}
        }
    },
    watch: {
        item: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                this.program = deepCopy(newValue)
            }
        }
    },
    methods: {
        updateItem() {
            this.$emit('updateItem', this.program, this.index)
        },
        removeItem() {
            this.$emit('removeItem', this.index)
        },
        handlerMoveToFirst() {
            this.$emit('updateOrder', SpaceNavigationAction.FIRST, this.index)
        },
        handlerMoveToNext() {
            this.$emit('updateOrder', SpaceNavigationAction.NEXT,  this.index)
        },
        handlerMoveToPrevious() {
            this.$emit('updateOrder', SpaceNavigationAction.PREVIOUS, this.index)
        },
        handlerMoveToLast() {
            this.$emit('updateOrder', SpaceNavigationAction.LAST, this.index)
        },
    }
}
</script>